import http from "./http.service";

/**
 * Los usuarios y los roles de la cuenta del vendedor. Mismo contrato que `estudio-usuarios.service`
 * y `roles.service` de tienda-admin.
 */

/** Un permiso del catalogo, agrupado por modulo, con su etiqueta. Las claves son el enum `Permiso` del back. */
export const PERMISO_CATALOGO = [
    {
        grupo: "General", permisos: [
            {key: "ESTADISTICAS", label: "Estadísticas y qué están buscando"},
            {key: "MI_CUENTA", label: "Mi cuenta (Mercado Pago, ARCA y contactos)"},
            {key: "USUARIOS", label: "Usuarios y roles"},
        ]
    },
    {
        grupo: "Publicaciones", permisos: [
            {key: "PUBLICACIONES", label: "Ver, crear y editar publicaciones"},
            {key: "OFERTAS", label: "Ofertas"},
        ]
    },
    {
        grupo: "Ventas", permisos: [
            {key: "VENTAS", label: "Ver y gestionar ventas"},
            {key: "MENSAJES", label: "Responder mensajes de compradores"},
            {key: "FACTURACION", label: "Emitir y ver facturas (ARCA)"},
        ]
    },
];

class CuentaUsuariosService {

    info(): Promise<any> {
        return http.get("/api/cuenta/usuarios/info");
    }

    buscar(searchDTO: any): Promise<any> {
        return http.post("/api/cuenta/usuarios/buscar", searchDTO);
    }

    crearUsuario(body: any): Promise<any> {
        return http.post("/api/cuenta/usuarios/crear", body);
    }

    cambiarRol(relId: number, rolCuentaId: number): Promise<any> {
        return http.post("/api/cuenta/usuarios/actualizar-rol", {relId, rolCuentaId});
    }

    resetPassword(relId: number, newPassword: string): Promise<any> {
        return http.post("/api/cuenta/usuarios/reset-password", {relId, newPassword});
    }

    eliminar(relId: number): Promise<any> {
        return http.post(`/api/cuenta/usuarios/eliminar/${relId}`, {});
    }

    roles(): Promise<any> {
        return http.get("/api/cuenta/roles");
    }

    crearRol(nombre: string, permisos: string[]): Promise<any> {
        return http.post("/api/cuenta/roles", {nombre, permisos});
    }

    actualizarRol(id: number, nombre: string, permisos: string[]): Promise<any> {
        return http.put(`/api/cuenta/roles/${id}`, {nombre, permisos});
    }

    eliminarRol(id: number): Promise<any> {
        return http.delete(`/api/cuenta/roles/${id}`);
    }
}

const cuentaUsuariosService = new CuentaUsuariosService();
export default cuentaUsuariosService;
